import { render, staticRenderFns } from "./geren.vue?vue&type=template&id=24920e77"
import script from "./geren.vue?vue&type=script&lang=js"
export * from "./geren.vue?vue&type=script&lang=js"
import style0 from "./geren.vue?vue&type=style&index=0&id=24920e77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports